module.exports = __webpack_public_path__ + "img/xmbwhx-img.c34bf0f1.png";